/*
 * Copyright (c) Nexign, JSC, 2023.
 */
/**
 *
 *
 * @author Evgeniy Naumov
 * @version 1.23.2
 * @since 1.23.2
 */

import { IPageProductsTranslation } from '@/main/modules/internationalization/types/pages/products';
import declination from '@/main/utils/declination';

import { IProductCardTariffField, IProductCardTariffFieldPrice } from '../tariffsAndServicesProductTariffTypes';

export const formatTariffCashback = (
    productsTranslation: IPageProductsTranslation,
    cashback?: IProductCardTariffField<IProductCardTariffFieldPrice>,
    payment?: IProductCardTariffField<IProductCardTariffFieldPrice>,
): IProductCardTariffField<IProductCardTariffFieldPrice> | undefined => {
    if (!cashback) return undefined;
    const cashbackHint = payment ? (payment.value.value * cashback.value.value) / 100 : null;
    return {
        title: cashback.title,
        value: {
            value: cashback.value.value,
            unit: !!cashbackHint
                ? `${cashbackHint.toFixed(2)} ${declination(cashbackHint, productsTranslation.cards.cashbackUnit)} ${
                      productsTranslation.cards.cashbackPeriod
                  }`
                : '',
        },
    };
};
